const Solicitar = () => {
  return (
    <div className="w-full bg-white py-20 px-4 md:px-16 flex flex-col md:flex-row gap-12">
      {/* Información y descripción */}
      <div className="md:w-1/2 flex flex-col justify-center gap-6">
        <h2 className="text-purple-900 text-3xl md:text-5xl font-bold">
          Envíenos un mensaje
        </h2>
        <p className="text-gray-500 text-base md:text-lg">
          ¿Tiene una pregunta? Estamos aquí para ayudarle. Envíenos un mensaje y nos pondremos en contacto con usted lo antes posible.
        </p>
        <div className="w-full h-64 md:h-96 rounded-lg overflow-hidden shadow-md mt-4">
          <iframe
            title="mapa"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.9601067463673!2d-98.22010203044394!3d19.026751998885477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc0b519f1e6a1%3A0x3b1713864ce867a5!2sPriv.%2011%20A%20Sur%2C%20Prados%20Agua%20Azul%2C%2072430%20Heroica%20Puebla%20de%20Zaragoza%2C%20Pue.!5e0!3m2!1ses-419!2smx!4v1759868416534!5m2!1ses-419!2smx"
            className="w-full h-full border-0"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Formulario */}
      <form className="md:w-1/2 flex flex-col gap-5 bg-gray-50 p-8 rounded-xl shadow-lg">
        <input
          type="text"
          placeholder="Nombre completo"
          className="border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          className="border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
        <input
          type="tel"
          placeholder="Teléfono"
          className="border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
        <input
          type="text"
          placeholder="Ciudad desde la que escribe"
          className="border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
        <textarea
          rows="4"
          placeholder="Mensaje"
          className="border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
        ></textarea>

        <button
          type="submit"
          className="w-full bg-purple-900 text-white py-3 rounded-full font-semibold hover:bg-purple-800 transition"
        >
          Enviar solicitud
        </button>
      </form>
    </div>
  );
};

export default Solicitar;
